import { default as indexH51KgkIPnPMeta } from "E:/TyApp/pages/demand/progress/index.vue?macro=true";
import { default as indexIrbNIQRhZ7Meta } from "E:/TyApp/pages/demand/requisition/index.vue?macro=true";
import { default as indexPabpPDqPpGMeta } from "E:/TyApp/pages/home/index.vue?macro=true";
import { default as index1WtXoRIGWHMeta } from "E:/TyApp/pages/index.vue?macro=true";
import { default as indexQyWWEKcpN7Meta } from "E:/TyApp/pages/inquiry/list/index.vue?macro=true";
import { default as indexmnU492WBgRMeta } from "E:/TyApp/pages/login/index.vue?macro=true";
export default [
  {
    name: "demand-progress___en",
    path: "/en/demand/progress",
    meta: indexH51KgkIPnPMeta || {},
    component: () => import("E:/TyApp/pages/demand/progress/index.vue")
  },
  {
    name: "demand-progress___zh",
    path: "/demand/progress",
    meta: indexH51KgkIPnPMeta || {},
    component: () => import("E:/TyApp/pages/demand/progress/index.vue")
  },
  {
    name: "demand-progress___ja",
    path: "/ja/demand/progress",
    meta: indexH51KgkIPnPMeta || {},
    component: () => import("E:/TyApp/pages/demand/progress/index.vue")
  },
  {
    name: "demand-requisition___en",
    path: "/en/demand/requisition",
    meta: indexIrbNIQRhZ7Meta || {},
    component: () => import("E:/TyApp/pages/demand/requisition/index.vue")
  },
  {
    name: "demand-requisition___zh",
    path: "/demand/requisition",
    meta: indexIrbNIQRhZ7Meta || {},
    component: () => import("E:/TyApp/pages/demand/requisition/index.vue")
  },
  {
    name: "demand-requisition___ja",
    path: "/ja/demand/requisition",
    meta: indexIrbNIQRhZ7Meta || {},
    component: () => import("E:/TyApp/pages/demand/requisition/index.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    meta: indexPabpPDqPpGMeta || {},
    component: () => import("E:/TyApp/pages/home/index.vue")
  },
  {
    name: "home___zh",
    path: "/home",
    meta: indexPabpPDqPpGMeta || {},
    component: () => import("E:/TyApp/pages/home/index.vue")
  },
  {
    name: "home___ja",
    path: "/ja/home",
    meta: indexPabpPDqPpGMeta || {},
    component: () => import("E:/TyApp/pages/home/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("E:/TyApp/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/",
    component: () => import("E:/TyApp/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("E:/TyApp/pages/index.vue")
  },
  {
    name: "inquiry-list___en",
    path: "/en/inquiry/list",
    meta: indexQyWWEKcpN7Meta || {},
    component: () => import("E:/TyApp/pages/inquiry/list/index.vue")
  },
  {
    name: "inquiry-list___zh",
    path: "/inquiry/list",
    meta: indexQyWWEKcpN7Meta || {},
    component: () => import("E:/TyApp/pages/inquiry/list/index.vue")
  },
  {
    name: "inquiry-list___ja",
    path: "/ja/inquiry/list",
    meta: indexQyWWEKcpN7Meta || {},
    component: () => import("E:/TyApp/pages/inquiry/list/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("E:/TyApp/pages/login/index.vue")
  },
  {
    name: "login___zh",
    path: "/login",
    component: () => import("E:/TyApp/pages/login/index.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    component: () => import("E:/TyApp/pages/login/index.vue")
  }
]